import { inviteIcon, conferenceIcon, guestIcon } from 'assets/images';

export const cardsTexts = [
  {
    text: 'Video_call_li_1_',
    id: 1,
    icon: inviteIcon,
  },
  {
    text: 'Video_call_li_5_',
    id: 2,
    icon: conferenceIcon,
  },
  {
    text: 'Video_call_li_3_',
    id: 3,
    icon: guestIcon,
  },
];
